import IconSvg from './assets/icons/32/internal.svg';
import { FC } from 'react';
const Icon: FC = () => <img alt="intenal warning" src={IconSvg} width="32px" height="32px" />;

export default Icon;
